<template>
  <div v-if="!tokenExpire">
    <div
      class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
    >
      <div class="flex flex-row items-end">
        <div
          class="bg-yellow-400 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
        >
          PV
        </div>
        <h2 class="text-lg font-medium ml-4">รายละเอียด {{ pv.pv_no }}</h2>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
      <div class="intro-y col-span-12">
        <div class="mt-5">
          <div class="h-10 w-full text-center my-20" v-if="loadingPage">
            <LoadingIcon icon="oval" class="w-12 h-12" />
          </div>
          <div class="horizontal-form" v-else>
            <div class="mb-4" v-if="isApprove">
              <ApprovePV
                :pv-id="pv.pv_id"
                :activity="pv.activity_list"
                :token="token"
                :employee-id="pv.claim_id"
                :show="pv.is_approve_token_used == 0"
                :edit="pv.flag_edit == 1"
                :approver-info="pv.approver_info"
                @reload="reloadPV"
              />
            </div>
            <div class="mb-4">
              <DocumentPath
                key="document-path"
                :document-path="pv.document_path_array"
                :status-code="pv.status_code"
                :flag-edit="pv.flag_edit"
                :next-status-code="pv.next_status"
                :approve-result="pv.approve_result_array"
              />
            </div>
            <HeaderCompany
              :img-logo="pv.pv_comp.comp_logo"
              :status-name="pv.status_name"
              :participants="pv.participants"
              :document-path="pv.document_path_text_array"
            />
            <div class="mt-5">
              <TableSummaryCost :items="pv.itemSummary" />
            </div>
            <div class="box intro-y mt-5 p-5">
              <HeaderOwner
                :reqName="pv.req_name"
                :companyName="pv.pv_comp.comp_name_th"
                :buNo="pv.bu_no"
                :buName="pv.bu_name"
                :telephone="pv.telephone"
              />
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 mt-5 lg:gap-4">
              <div class="intro-y box p-5 col-span-2">
                <div class="font-bold text-lg">ข้อมูลค่าใช้จ่าย</div>
                <div class="mt-4">
                  <label class="form-label font-bold"
                    >หมายเลขใบกำกับภาษี:</label
                  >
                  <div>{{ pv.po_no }}</div>
                </div>
                <div class="mt-4">
                  <label class="form-label font-bold">รายละเอียด:</label>
                  <div
                    class="overflow-x-auto"
                    v-html="
                      pv.req_detail
                        ? pv.req_detail.replaceAll('\n', '<br />')
                        : ''
                    "
                  ></div>
                </div>
                <div class="mt-4">
                  <label for="" class="form-label font-bold"
                    >เอกสารจาก Memo:</label
                  >
                  <div>
                    <a :href="pv.ememo_link" target="_blank">{{
                      pv.ememo_title
                    }}</a>
                  </div>
                </div>
                <div class="mt-4 col-span-1">
                  <label class="form-label font-bold">ไฟล์แนบ:</label>
                  <AttachFilePreview :data="pv.file_attach_array" grid />
                </div>
              </div>
              <div class="intro-y box p-5 mt-5 lg:mt-0">
                <div class="font-bold text-lg mb-4">ข้อมูลด้านบัญชี</div>
                <GLDate
                  url="reimbursement/pv/updatePvGldate"
                  :id="pv.pv_id"
                  :glDate="pv.glDate"
                  :isPermissionVat="pv.is_permission_vat"
                  :isApprove="isApprove"
                  :isClaim="isClaim"
                  classLabel="flex flex-row justify-between"
                />
                <div class="flex flex-row justify-between">
                  <label class="form-label font-bold">สกุลเงิน:</label>
                  <div class="">{{ pv.currency }}</div>
                </div>
                <div class="flex flex-row justify-between">
                  <label class="form-label font-bold">ชำระโดย:</label>
                  <div>{{ pv.petty_cash.label }}</div>
                </div>
                <div class="flex flex-row justify-between">
                  <label class="form-label font-bold">จ่ายให้:</label>
                  <div>
                    {{
                      pv.payee_no && pv.payee_no != ''
                        ? `(${pv.payee_no}) - ${pv.payee_name}`
                        : 'ไม่ระบุ'
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-5 gap-4">
              <div class="intro-y box p-5 space-y-4">
                <div class="text-lg font-bold">รายการเบิก</div>
                <div
                  class="border rounded p-5"
                  v-for="(item, index) in pv.items"
                  :key="item.pv_item_id"
                >
                  <div class="font-bold">ลำดับที่ {{ index + 1 }}.</div>
                  <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4">
                    <!-- col-1 -->
                    <div
                      v-if="
                        !(pv.is_permission_vat != 0 && isApprove && !isClaim)
                      "
                    >
                      <div class="text-lg font-bold">รายละเอียดค่าใช้จ่าย</div>
                      <div class="flex justify-between">
                        <div class="font-bold">เลขที่ใบเสร็จ/ใบกำกับภาษี:</div>
                        <div>{{ item.receipt_no }}</div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">
                          วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี:
                        </div>
                        <div>{{ item.receipt_date }}</div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">Vendor:</div>
                        <div>
                          {{
                            item.vendor_no && item.vendor_no != ''
                              ? `(${item.vendor_no}) - ${item.vendor_name}`
                              : 'ไม่ระบุ'
                          }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">จ่ายให้:</div>
                        <div>
                          {{
                            item.payee_no && item.payee_no != ''
                              ? `(${item.payee_no}) - ${item.payee_name}`
                              : 'ไม่ระบุ'
                          }}
                        </div>
                      </div>
                      <div>
                        <div class="font-bold">รายละเอียดค่าใช้จ่าย:</div>
                        <div
                          class="overflow-x-auto"
                          v-html="
                            item.detail
                              ? item.detail.replaceAll('\n', '<br>')
                              : ''
                          "
                        ></div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">จำนวนเงิน (บาท):</div>
                        <div>{{ numberFormat(item.amount) }}</div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">
                          ภาษีมูลค่าเพิ่ม
                          {{ item.vat_rate > 0 ? `(${item.vat_rate}%)` : '' }}:
                        </div>
                        <div>{{ numberFormat(item.vat) }}</div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">
                          ภาษีหัก ณ ที่จ่าย
                          {{
                            item.wh_tax_rate > 0
                              ? `(${item.wh_tax_rate}%)`
                              : ''
                          }}:
                        </div>
                        <div>{{ numberFormat(item.wh_tax) }}</div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">ค่าใช้จ่ายจริง:</div>
                        <div>{{ numberFormat(item.actual_cost) }}</div>
                      </div>
                      <!-- <div class="text-theme-6 font-bold">
                        {{
                          item.is_itself_tax === 1 ? '* บริษัทรับภาระเอง' : ''
                        }}
                      </div> -->
                    </div>
                    <div class="space-y-4" v-else>
                      <div>
                        <label for="" class="form-label "
                          >เลขที่ใบเสร็จ/ใบกำกับภาษี
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="item.receipt_no"
                          maxlength="50"
                          placeholder="(ไม่เกิน 50 ตัวอักษร)"
                        />
                      </div>
                      <div class="p-fluid p-grid">
                        <div class="p-field p-field-sm">
                          <label for="">วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี </label>
                          <Calendar
                            class="mt-2"
                            inputStyle="padding:0.5rem 0.75rem;"
                            v-model="item.receipt_date"
                            dateFormat="yy-mm-dd"
                            placeholder="2022-01-01"
                          />
                        </div>
                      </div>
                      <div class="">
                        <label for="" class="form-label font-bold"
                          >Vendor:
                        </label>
                        <div>
                          {{
                            item.vendor_no && item.vendor_no != ''
                              ? `(${item.vendor_no}) - ${item.vendor_name}`
                              : 'ไม่ระบุ'
                          }}
                        </div>
                      </div>
                      <div class="">
                        <label for="" class="form-label font-bold"
                          >จ่ายให้:
                        </label>
                        <div>
                          {{
                            item.payee_no && item.payee_no != ''
                              ? `(${item.payee_no}) - ${item.payee_name}`
                              : 'ไม่ระบุ'
                          }}
                        </div>
                      </div>
                      <div class="">
                        <label for="" class="form-label font-bold"
                          >รายละเอียดค่าใช้จ่าย:
                        </label>
                        <div
                          class="overflow-x-auto"
                          v-html="
                            item.detail
                              ? item.detail.replaceAll('\n', '<br>')
                              : ''
                          "
                        ></div>
                      </div>
                      <div class="">
                        <label for="" class="form-label ">จำนวนเงิน(บาท)</label>
                        <div>{{ numberFormat(item.amount) }}</div>
                      </div>
                      <div class="">
                        <label for="" class="form-label "
                          >ภาษีมูลค่าเพิ่ม</label
                        >
                        <div class="grid grid-cols-4 space-x-2">
                          <input
                            type="number"
                            class="form-control col-span-2"
                            min="0"
                            v-model.number="item.vat"
                            @keyup="calVat(index)"
                            @change="calVat(index)"
                            :disabled="!item.taxVatProcess"
                          />
                          <input
                            type="number"
                            class="form-control"
                            v-model.number="item.vat_rate"
                            min="0"
                            max="100"
                            @keyup="calVatProcess(index)"
                            @change="calVatProcess(index)"
                          />
                          <button
                            class="btn"
                            :class="[
                              item.taxVatProcess
                                ? 'btn-primary'
                                : 'btn-secondary'
                            ]"
                            @click="
                              ;[
                                (item.taxVatProcess = !item.taxVatProcess),
                                calVatProcess(index)
                              ]
                            "
                          >
                            คำนวณ
                          </button>
                        </div>
                      </div>
                      <div class="">
                        <label for="" class="form-label "
                          >ภาษีหัก ณ ที่จ่าย</label
                        >
                        <div class="grid grid-cols-4 space-x-2">
                          <input
                            type="number"
                            class="form-control col-span-2"
                            min="0"
                            v-model.number="item.wh_tax"
                            @keyup="calTax(index)"
                            @change="calTax(index)"
                            :disabled="!item.taxWhProcess"
                          />
                          <input
                            type="number"
                            class="form-control"
                            v-model.number="item.wh_tax_rate"
                            min="0"
                            max="100"
                            @keyup="calTaxProcess(index)"
                            @change="calTaxProcess(index)"
                          />
                          <button
                            class="btn"
                            :class="[
                              item.taxWhProcess
                                ? 'btn-primary'
                                : 'btn-secondary'
                            ]"
                            @click="
                              ;[
                                (item.taxWhProcess = !item.taxWhProcess),
                                calTaxProcess(index)
                              ]
                            "
                          >
                            คำนวณ
                          </button>
                        </div>
                      </div>
                      <!-- <div class="form-check mt-2">
                        <input
                          id="isItselfTax"
                          type="checkbox"
                          class="form-check-input"
                          v-model="item.is_itself_tax"
                        />
                        <label
                          for="isItselfTax"
                          class="form-check-label text-theme-6"
                          >บริษัทรับภาระเอง</label
                        >
                      </div> -->
                      <div class="">
                        <label for="" class="form-label ">ค่าใช้จ่ายจริง</label>
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="item.actual_cost"
                        />
                      </div>
                      <div>
                        <button
                          class="btn btn-warning"
                          @click="updateItemActualCost(index)"
                        >
                          อัพเดท
                        </button>
                      </div>
                    </div>
                    <!-- col-2 -->
                    <div class="col-span-2 mt-4 lg:mt-0">
                      <div>
                        <div class="text-lg font-bold">รายละเอียดงบประมาณ</div>
                        <div class="flex justify-between">
                          <div class="font-bold">ปีงบประมาณ:</div>
                          <div>{{ item.budget_year }}</div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">ชนิดงบประมาณ:</div>
                          <div>
                            {{
                              item.budget_subledger
                                ? 'งบประมาณโครงการ'
                                : 'งบประมาณหน่วยงาน'
                            }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">ใช้งบประมาณของหน่วยงาน:</div>
                          <div>
                            {{ item.budget_bu_name }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">รหัส BU:</div>
                          <div>
                            {{ item.budget_bu_code }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">Account Code:</div>
                          <div>
                            {{ item.budget_code }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">Subsidiary:</div>
                          <div>
                            {{ item.budget_subsidiary }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">Account Name:</div>
                          <div>
                            {{ item.budget_name }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">
                            Subledger:
                          </div>
                          <div>
                            {{ item.budget_subledger }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">
                            Subledger Name:
                          </div>
                          <div>
                            {{ item.budget_subledger_name }}
                          </div>
                        </div>
                      </div>
                      <!-- col-3 -->
                      <div class="mt-4">
                        <div class="text-lg font-bold">รายละเอียดภาษี</div>
                        <div
                          v-if="
                            !(
                              pv.is_permission_vat != 0 &&
                              isApprove &&
                              !isClaim
                            )
                          "
                        >
                          <BcVatLabel
                            v-if="isBc"
                            :key="index"
                            :bcVatProd="item.bc_vat_prod"
                            :bcWhtBus="item.bc_wht_bus"
                            :bcWhtProd="item.bc_wht_prod"
                            :bcElim="item.bc_elim"
                          />
                          <!-- <div class="flex justify-between">
                            <div class="font-bold">Tax Rate:</div>
                            <div>
                              {{ getTaxRate(item.tax_rate) }}
                            </div>
                          </div>
                          <div class="flex justify-between">
                            <div class="font-bold">GL Offset:</div>
                            <div>{{ item.gl_offset }}</div>
                          </div>
                          <div class="flex justify-between">
                            <div class="font-bold">Cat Code:</div>
                            <div>{{ getCatCode(item.cat_code) }}</div>
                          </div>
                          <div class="flex justify-between">
                            <div class="font-bold">
                              Analysis Code 1:
                            </div>
                            <div>
                              {{
                                getAnalysisCodeText(
                                  item.analysis_code_array.analysis_code_1
                                )
                              }}
                            </div>
                          </div>
                          <div class="flex justify-between">
                            <div class="font-bold">
                              Analysis Code 2:
                            </div>
                            <div>
                              {{
                                getAnalysisCodeText(
                                  item.analysis_code_array.analysis_code_2
                                )
                              }}
                            </div>
                          </div>
                          <div class="flex justify-between">
                            <div class="font-bold">
                              Analysis Code 9:
                            </div>
                            <div>
                              {{
                                getAnalysisCodeText(
                                  item.analysis_code_array.analysis_code_9
                                )
                              }}
                            </div>
                          </div>
                          <div class="flex justify-between">
                            <div class="font-bold">
                              Analysis Code 10 (Tax Rate):
                            </div>
                            <div>
                              {{
                                getAnalysisCodeText(
                                  item.analysis_code_array.analysis_code_10
                                )
                              }}
                            </div>
                          </div>
                          <div class="flex justify-between">
                            <div class="font-bold">
                              Asset Code:
                            </div>
                            <div>
                              {{ item.asset_code || 'ไม่ระบุ' }}
                            </div>
                          </div>
                          <div class="flex justify-between">
                            <div class="font-bold">
                              Asset Indicator:
                            </div>
                            <div>
                              {{ item.asset_indicator || '-' }}
                            </div>
                          </div> -->
                        </div>
                        <div v-else class="space-y-4">
                          <!-- <div
                            class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4"
                          >
                            <div class="space-y-4">
                              <div class="">
                                <label for="" class="form-label "
                                  >Tax Rate</label
                                >
                                <select
                                  name=""
                                  class="form-control form-select"
                                  v-model="item.tax_rate"
                                >
                                  <option :value="null">-- select --</option>
                                  <option
                                    :value="tax.tax_code"
                                    v-for="tax in taxRateOptions"
                                    :key="tax.tax_code"
                                    >{{ tax.tax_code }} -
                                    {{ tax.tax_name }}</option
                                  >
                                </select>
                              </div>
                              <div class="">
                                <label for="" class="form-label "
                                  >GL Offset</label
                                >
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="item.gl_offset"
                                  maxlength="4"
                                />
                              </div>
                              <div class="">
                                <label for="" class="form-label "
                                  >Cat Code</label
                                >
                                <select
                                  name=""
                                  class="form-control form-select"
                                  v-model="item.cat_code"
                                >
                                  <option :value="null">-- select --</option>
                                  <option
                                    :value="cat.cat_code"
                                    v-for="cat in catCodeOptions"
                                    :key="cat.cat_code"
                                    >{{ cat.cat_code }} -
                                    {{ cat.cat_name }}</option
                                  >
                                </select>
                                <div class="text-theme-6 text-sm">
                                  * ทั้งนี้ code : 2400 ไม่ต้องระบุ
                                </div>
                              </div>
                            </div>
                          </div> -->
                          <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

                            <div>
                              <label for="" class="form-label "
                                >Analysis Code 1</label
                              >
                              <select
                                name=""
                                class="form-control form-select"
                                v-model="
                                  item.analysis_code_array.analysis_code_1
                                "
                              >
                                <option value="">-- select --</option>
                                <option
                                  :value="analysisCode.code"
                                  v-for="analysisCode in analysisCodeOption1"
                                  :key="analysisCode.code"
                                  >{{ analysisCode.code }} -
                                  {{ analysisCode.name }}</option
                                >
                              </select>
                            </div>
                            <div>
                              <label for="" class="form-label "
                                >Analysis Code 2</label
                              >
                              <select
                                name=""
                                class="form-control form-select"
                                v-model="
                                  item.analysis_code_array.analysis_code_2
                                "
                              >
                                <option value="">-- select --</option>
                                <option
                                  :value="analysisCode.code"
                                  v-for="analysisCode in analysisCodeOption2"
                                  :key="analysisCode.code"
                                  >{{ analysisCode.code }} -
                                  {{ analysisCode.name }}</option
                                >
                              </select>
                            </div>
                            <div>
                              <label for="" class="form-label "
                                >Analysis Code 9</label
                              >
                              <select
                                name=""
                                class="form-control form-select"
                                v-model="
                                  item.analysis_code_array.analysis_code_9
                                "
                              >
                                <option value="">-- select --</option>
                                <option
                                  :value="analysisCode.code"
                                  v-for="analysisCode in analysisCodeOption9"
                                  :key="analysisCode.code"
                                  >{{ analysisCode.code }} -
                                  {{ analysisCode.name }}</option
                                >
                              </select>
                            </div>
                            <div>
                              <label for="" class="form-label "
                                >Analysis Code 10 (Tax Rate)</label
                              >
                              <select
                                name=""
                                class="form-control form-select"
                                :class="{
                                  'border-theme-6':
                                    item.vat > 0 &&
                                    item.analysis_code_array.analysis_code_10 ==
                                      'Z'
                                }"
                                v-model="
                                  item.analysis_code_array.analysis_code_10
                                "
                              >
                                <option value="">-- select --</option>
                                <option
                                  :value="analysisCode.code"
                                  v-for="analysisCode in analysisCodeOption10"
                                  :key="analysisCode.code"
                                  >{{ analysisCode.code }} -
                                  {{ analysisCode.name }}</option
                                >
                              </select>
                            </div>
                            <div>
                              <label for="" class="form-label "
                                >Asset Code</label
                              >
                              <input
                                type="text"
                                class="form-control"
                                v-model="item.asset_code"
                              />
                            </div>
                            <div>
                              <label for="" class="form-label "
                                >Asset Indicator</label
                              >
                              <select
                                name=""
                                class="form-control form-select"
                                v-model="item.asset_indicator"
                              >
                                <option value="">-- select --</option>
                                <option
                                :value="tax.tax_code"
                                v-for="tax in taxRateOptions"
                                :key="tax.tax_code"
                                >{{ tax.tax_code }} - {{ tax.tax_name }}</option
                              >
                              </select>
                            </div>
                          </div> -->
                          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <BcVat
                              :key="index"
                              :bcVatProd="item.bc_vat_prod"
                              :bcWhtBus="item.bc_wht_bus"
                              :bcWhtProd="item.bc_wht_prod"
                              :bcElim="item.bc_elim"
                              v-model:vatProd="item.bc_vat_prod"
                              v-model:whtBus="item.bc_wht_bus"
                              v-model:whtProd="item.bc_wht_prod"
                              v-model:elim="item.bc_elim"
                              :invalidVat="
                                item.vat > 0 && item.bc_vat_prod == null
                              "
                              :invalidWhtBus="
                                item.wh_tax > 0 && item.bc_wht_bus == null
                              "
                              :invalidWhtProd="
                                item.wh_tax > 0 && item.bc_wht_prod == null
                              "
                            />
                          </div>
                          <div class="mt-5">
                            <button
                              class="btn btn-warning"
                              @click="updateItemVat(index)"
                            >
                              อัพเดท
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <TableHistory :items="pv.historyArray" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <TryLogin :tokenExpireText="tokenExpireText" />
  </div>
  <Notification />
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  reactive,
  onMounted,
  ref,
  onUnmounted
} from 'vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'
import { api } from '../../../utils/api'
import alert from '@/helpers/alert'
import helpers from '../../../helpers'
import ApprovePV from '@/components/approve-pv/Main.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import AttachFilePreview from '@/components/attach-file/Preview.vue'
import Notification from '@/components/notification/Notification.vue'
import TryLogin from '@/components/TryLogin.vue'
import HeaderCompany from '@/components/HeaderCompany.vue'
import HeaderOwner from '@/components/HeaderOwner.vue'
import GLDate from '@/components/GLDate.vue'
import BcVatLabel from '../../../components/BcVatLabel.vue'
import BcVat from '../../../components/BcVat.vue'

export default defineComponent({
  components: {
    ApprovePV,
    DocumentPath,
    TableSummaryCost,
    AttachFilePreview,
    TableHistory,
    Notification,
    TryLogin,
    HeaderCompany,
    HeaderOwner,
    GLDate,
    BcVatLabel,
    BcVat
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const loadingPage = computed(() => store.state.global.loadingPage)

    const taxRateOptions = computed(() => store.state.global.taxRate)
    const catCodeOptions = computed(() => store.state.global.catCode)
    const isBc = computed(() => process.env.VUE_APP_ACCOUNT_MODULE == 'BC365')

    // const analysisCodeOption = computed(() => store.state.global.analysisCode)
    const analysisCodeOption1 = computed(() => store.state.global.analysisCode1)
    const analysisCodeOption2 = computed(() => store.state.global.analysisCode2)
    const analysisCodeOption9 = computed(() => store.state.global.analysisCode9)
    const analysisCodeOption10 = computed(
      () => store.state.global.analysisCode10
    )

    const { numberFormat, numberFormat2, dateFormat } = helpers

    const isClaim = computed(() => store.state.pv.isClaim)

    const tokenExpire = ref(false)
    const tokenExpireText = ref('')
    const token = ref(route.query.token)
    const isOwner = ref(false)
    const isApprove = ref(false)

    const pv = reactive({
      owner_name: '',
      pv_no: '',
      status_code: null,
      next_status: null,
      pv_id: null,
      claim_id: null,
      activity_list: [],
      document_path_text_array: [],
      document_path_array: [],
      approve_result_array: [],
      pv_comp: {
        comp_name_th: '',
        comp_logo: ''
      },
      telephone: '',
      glDate: null,
      bu_no: '',
      bu_name: '',
      currency: '',
      petty_cash: {},
      req_name: '',
      req_detail: '',
      po_no: '',
      ememo_id: '',
      ememo_title: '',
      ememo_link: '',
      flag_edit: 0,
      file_attach_array: [],
      items: [],
      itemSummary: [],
      historyArray: [],
      is_approve_token_used: 0,
      status_name: '',
      participants: '',
      payee_no: '',
      payee_name: '',
      is_permission_vat: false,
      approver_info: {}
    })

    const reloadPV = () => {
      loadPV()
    }

    const calVat = i => {
      pv.items[i].actual_cost = numberFormat2(
        pv.items[i].amount + pv.items[i].vat - pv.items[i].wh_tax
      )
    }

    const calTax = i => {
      pv.items[i].actual_cost = numberFormat2(
        pv.items[i].amount + pv.items[i].vat - pv.items[i].wh_tax
      )
    }

    const calVatProcess = i => {
      if (pv.items[i].taxVatProcess) {
        if (pv.items[i].vat_rate > 0 && pv.items[i].vat_rate <= 100) {
          pv.items[i].vat = (pv.items[i].amount * pv.items[i].vat_rate) / 100
        } else {
          pv.items[i].vat = 0
        }
      } else {
        pv.items[i].vat = 0
      }
      calVat(i)
    }

    const calTaxProcess = i => {
      if (pv.items[i].taxWhProcess) {
        if (pv.items[i].wh_tax_rate > 0 && pv.items[i].wh_tax_rate <= 100) {
          pv.items[i].wh_tax =
            (pv.items[i].amount * pv.items[i].wh_tax_rate) / 100
        } else {
          pv.items[i].wh_tax = 0
        }
      } else {
        pv.items[i].wh_tax = 0
      }
      calTax(i)
    }

    const calActualCost = i => {
      pv.items[i].actual_cost =
        pv.items[i].amount + pv.items[i].vat - pv.items[i].wh_tax
    }
    const loadPV = async () => {
      if (route.query.token) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/reimbursement/pv/getByToken/${route.query.token}`
          )
          .then(res => {
            if (res.code == 200) {
              // console.log('res: ', res)
              pv.pv_id = res.data.pv_id
              pv.activity_list = res.data.allow_list_array
                ? res.data.allow_list_array.activity_list
                : []
              pv.owner_name = res.data.owner_name
              pv.is_approve_token_used = res.data.is_approve_token_used
              pv.pv_no = res.data.doc_no_full
              pv.claim_id = res.data.claim_id
              pv.status_code = res.data.status_code
              pv.next_status = res.data.next_status
              pv.document_path_text_array = res.data.document_path_text_array
              pv.document_path_array = res.data.document_path_array
              pv.approve_result_array = res.data.approve_result_array
              pv.req_name = res.data.req_name
              pv.telephone = res.data.telephone
              pv.bu_no = res.data.bu_no
              pv.bu_name = res.data.bu_name
              pv.currency = res.data.currency
              pv.petty_cash = res.data.petty_cash
              pv.req_detail = res.data.req_detail
              pv.po_no = res.data.po_no
              pv.flag_edit = res.data.flag_edit
              pv.status_name = res.data.status_name
              pv.participants = res.data.participants
              pv.is_permission_vat = res.data.is_permission_vat == 1
              pv.itemSummary = res.data.itemSummary
              pv.payee_no = res.data.payee_no
              pv.payee_name = res.data.payee_name
              pv.glDate = res.data.gl_date !== null ? res.data.gl_date : ''
              pv.historyArray = res.data.history_array
              pv.approver_info = res.data.approver_info

              pv.ememo_id = res.data.ememo_id
              pv.ememo_title = res.data.ememo_title
              pv.ememo_link = `${process.env.VUE_APP_BASE_URL}/memo/myActivities/form/${res.data.ememo_id}/detail`
              pv.file_attach_array = res.data.file_attach_array

              pv.pv_comp = store.getters['global/companyFind'](res.data.pv_comp)
              pv.petty_cash = store.getters['global/cashFind'](
                res.data.petty_cash
              )

              pv.items = res.data.items.map(item => {
                item.taxVatProcess = item.vat > 0
                item.taxWhProcess = item.wh_tax > 0

                return item
              })

              isApprove.value = false
              if (res.data.allow_list_array && res.data.approver_info) {
                res.data.allow_list_array.activity_list.map(item => {
                  // if (item.employee_id == res.data.claim_id) {
                  if (item.employee_id == res.data.approver_info.employee_id) {
                    isApprove.value = true
                  }
                })
                // if (res.data.claim_id === null) {
                //   isApprove.value = true
                // }
              }
              // if (res.data.approver_info && res.data.claim_id != null) {
              //   if (res.data.approver_info.employee_id != res.data.claim_id) {
              //     isApprove.value = false
              //   }
              // }

              // pv.claim_id = res.data.claim_id
              store.commit(
                'pv/setIsClaim',
                res.data.claim_id === null && isApprove.value
              )

              store.commit('global/setOverBudget', {
                message:
                  res.data.is_over_budget == 1
                    ? 'เกินงบประมาณ'
                    : 'อยู่ในงบประมาณ',
                isOver: res.data.is_over_budget == 1,
                show: true
              })
            } else {
              tokenExpire.value = true
              tokenExpireText.value = res.validator.approve_token[0]
            }
          })
          .catch(e => {
            console.log('error: ', e)
            tokenExpire.value = true
          })
      }
    }

    const updateItemActualCost = async i => {
      const data = {
        receipt_no: pv.items[i].receipt_no,
        receipt_date: dateFormat(pv.items[i].receipt_date),
        vat_rate: pv.items[i].vat_rate,
        vat: pv.items[i].vat,
        wh_tax_rate: pv.items[i].wh_tax_rate,
        wh_tax: pv.items[i].wh_tax,
        actual_cost: pv.items[i].actual_cost
      }
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/reimbursement/pv/updateItemExpenses/${pv.items[i].pv_item_id}`,
          data
        )
        .then(res => {
          if (res.code == 200) {
            alert.success()
          } else {
            alert.error(res.message)
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const getTaxRate = taxRate => {
      if (taxRate) {
        const rate = taxRateOptions.value.find(
          item => item.tax_code === taxRate
        )
        if (rate) {
          return `${rate.tax_code} - ${rate.tax_name}`
        } else {
          return `ไม่พบรหัสที่: ${taxRate}`
        }
      } else {
        return 'ไม่ระบุ'
      }
    }

    const getCatCode = catCode => {
      if (catCode !== null) {
        const code = catCodeOptions.value.find(
          item => item.cat_code === catCode
        )
        return `${code.cat_code} - ${code.cat_name}`
      } else {
        return 'ไม่ระบุ'
      }
    }
    const updateItemVat = async index => {
      // if (pv.items[index].vat > 0 && pv.items[index].tax_rate == null) {
      //   alert.error('กรุณาเลือก Tax Rate')
      //   return
      // }
      if (pv.items[index].vat > 0 && pv.items[index].bc_vat_prod == null) {
        alert.error('กรุณาเลือก Vat Prod')
        return
      }
      if (
        pv.items[index].wh_tax > 0 &&
        (pv.items[index].bc_wht_bus == null ||
          pv.items[index].bc_wht_prod == null)
      ) {
        alert.error('กรุณาเลือก WHT Bus และ WHT Prod')
        return
      }
      const updateVat = {
        bc_vat_prod: pv.items[index].bc_vat_prod,
        bc_wht_bus: pv.items[index].bc_wht_bus,
        bc_wht_prod: pv.items[index].bc_wht_prod,
        bc_elim: pv.items[index].bc_elim
      }
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/reimbursement/pv/updateItemVat/${pv.items[index].pv_item_id}`,
          updateVat
        )
        .then(res => {
          if (res.code == 200) {
            alert.success()
          } else {
            alert.error()
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }
    // const updateItemVat = async index => {
    //   if (
    //     pv.items[index].vat > 0 &&
    //     pv.items[index].analysis_code_array.analysis_code_10 == 'Z'
    //   ) {
    //     alert.error('กรุณาเลือก Analysis Code 10')
    //     return
    //   }
    //   const updateVat = {
    //     cat_code: pv.items[index].cat_code,
    //     tax_rate: pv.items[index].tax_rate,
    //     gl_offset: pv.items[index].gl_offset
    //     // analysis_code_1: pv.items[index].analysis_code_array.analysis_code_1,
    //     // analysis_code_2: pv.items[index].analysis_code_array.analysis_code_2,
    //     // analysis_code_9: pv.items[index].analysis_code_array.analysis_code_9,
    //     // analysis_code_10: pv.items[index].analysis_code_array.analysis_code_10,
    //     // asset_code: pv.items[index].asset_code,
    //     // asset_indicator: pv.items[index].asset_indicator
    //   }
    //   await api
    //     .put(
    //       `${process.env.VUE_APP_API_URL}/reimbursement/pv/updateItemVat/${pv.items[index].pv_item_id}`,
    //       updateVat
    //     )
    //     .then(res => {
    //       if (res.code == 200) {
    //         alert.success()
    //       } else {
    //         alert.error()
    //       }
    //     })
    //     .catch(e => {
    //       alert.error(e.message)
    //     })
    // }

    const getAnalysisCodeText = code => {
      return store.getters['global/getAnalysisCodeText'](code)
    }

    onUnmounted(() => {
      console.log('unmounted page pv approve')
      store.commit('pv/initBtn')
      isOwner.value = false
      isApprove.value = false
    })

    onMounted(async () => {
      console.log('mounted page pv approve')
      await store.dispatch('global/loadCompanyToken')
      await store.dispatch('global/loadCash')
      // await store.dispatch('global/loadTaxRate')
      // await store.dispatch('global/loadCatCode')
      // await store.dispatch('global/loadOptionAnalysisCode')
      await store.dispatch('global/loadBc')
      await loadPV()
      // await store.commit('global/setCompanyDefault', { no: pv.pv_comp })
      store.commit('global/setLoadingPage', false)
    })

    return {
      pv,
      reloadPV,
      loadingPage,
      getTaxRate,
      getCatCode,
      numberFormat,
      dateFormat,
      isOwner,
      isApprove,
      token,
      tokenExpire,
      tokenExpireText,
      taxRateOptions,
      catCodeOptions,
      updateItemVat,
      isClaim,
      calVat,
      calTax,
      calVatProcess,
      calTaxProcess,
      calActualCost,
      updateItemActualCost,
      // analysisCodeOption,
      analysisCodeOption1,
      analysisCodeOption2,
      analysisCodeOption9,
      analysisCodeOption10,
      getAnalysisCodeText,
      isBc
    }
  }
})
</script>
